/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  selector: 'ellf-text-field',
  template: `
    <ellf-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ellf-text-input
        [maxlength]="maxlength"
        [controlType]="controlType"
        [placeholder]="placeholder"
        [hasError]="shouldShowError"
        [formControl]="formControl"
        [longText]="longText"
        [readOnly]="readOnly"
        (blur)="onBlur()"
        [rows]="rows"
      >
      </ellf-text-input>
    </ellf-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextFieldComponent extends BaseFormFieldComponent {
  @Input()
  controlType: 'text' | 'password' | 'tel' | 'email' = 'text';

  @Input()
  placeholder = '';

  @Input()
  longText = false;

  @Input()
  rows = 2;

  @Input()
  maxlength: number | null = null;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  onBlur() {
    this.blur.emit();
  }
}
